import { FileFormatsForRestoreType } from 'wizards/models/base/base-restore-forms-model';
import { SelectTargetComputerDefaultValue, SelectTargetComputerStepType } from 'wizards/models/select-target-computer-models';
import { RestoreAsDiskEnum, TypeDataStepValue } from 'wizards/models/type-data-models';

export type RestoreIbbTypeModel = {
  fileFormats: string[];
  selectTargetComputerStep: SelectTargetComputerStepType;
  typeDataStep: TypeDataStepValue;
};

export const RestoreIbbTypeSteps: RestoreIbbTypeModel = {
  fileFormats: FileFormatsForRestoreType,
  selectTargetComputerStep: SelectTargetComputerDefaultValue,
  typeDataStep: {
    restoreAs: RestoreAsDiskEnum.Physical,
    createAMI: false,
    selectedFileFormat: FileFormatsForRestoreType[0],
    valid: true
  }
};
